import SideSocialNetworks from './SideSocialNetworks';

export default SideSocialNetworks;